import { render } from "./ReportPageHeader.vue?vue&type=template&id=11349361"
import script from "./ReportPageHeader.vue?vue&type=script&lang=js"
export * from "./ReportPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__